var _path, _path2, _path3, _path4, _path5, _path6, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeliveryCarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.359 14.2949V15.8334C14.359 15.9694 14.305 16.0998 14.2088 16.196C14.1126 16.2922 13.9822 16.3462 13.8462 16.3462H12.3077C12.1717 16.3462 12.0413 16.2922 11.9451 16.196C11.849 16.0998 11.7949 15.9694 11.7949 15.8334V14.2949",
    stroke: "#1B51A4",
    strokeWidth: 1.02564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.61536 14.2949V15.8334C4.61536 15.9694 4.56133 16.0998 4.46516 16.196C4.36899 16.2922 4.23855 16.3462 4.10254 16.3462H2.56409C2.42808 16.3462 2.29764 16.2922 2.20147 16.196C2.1053 16.0998 2.05127 15.9694 2.05127 15.8334V14.2949",
    stroke: "#1B51A4",
    strokeWidth: 1.02564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2822 12.2437H12.3079",
    stroke: "#1B51A4",
    strokeWidth: 1.02564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.10254 12.2437H5.12818",
    stroke: "#1B51A4",
    strokeWidth: 1.02564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.02588 10.1924H15.3848",
    stroke: "#1B51A4",
    strokeWidth: 1.02564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3589 10.1923L12.443 5.88145C12.4027 5.7908 12.337 5.71378 12.2538 5.65973C12.1706 5.60567 12.0736 5.5769 11.9744 5.5769H4.43581C4.33661 5.5769 4.23954 5.60567 4.15637 5.65973C4.07319 5.71378 4.00748 5.7908 3.96719 5.88145L2.05127 10.1923V14.2948H14.3589V10.1923Z",
    stroke: "#1B51A4",
    strokeWidth: 1.02564,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_410)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.432 4.2441L18.25 4.0509C18.1808 3.8137 18.0862 3.5857 17.9678 3.3699L18.6578 2.3865C18.7136 2.3071 18.704 2.1989 18.6354 2.1301L17.8576 1.3527C17.7882 1.2835 17.679 1.2745 17.5994 1.3319L16.6308 2.0281C16.413 1.9077 16.183 1.8121 15.9444 1.7427L15.7382 0.565502C15.7214 0.469902 15.6384 0.399902 15.5412 0.399902H14.4412C14.3432 0.399902 14.2596 0.470902 14.2438 0.567702L14.0526 1.7385C13.8126 1.8075 13.5822 1.9021 13.3652 2.0209L12.3992 1.3309C12.3194 1.2739 12.2108 1.2831 12.1414 1.3521L11.364 2.1295C11.2954 2.1981 11.2858 2.3061 11.3416 2.3855L12.0214 3.3581C11.9004 3.5771 11.804 3.8089 11.7338 4.0501L10.5676 4.2443C10.4712 4.2603 10.4004 4.3439 10.4004 4.4415V5.5415C10.4004 5.6385 10.47 5.7215 10.5654 5.7385L11.7316 5.9453C11.8014 6.1859 11.8978 6.4177 12.0192 6.6373L11.331 7.5999C11.2742 7.6793 11.2832 7.7883 11.3522 7.8577L12.1298 8.6359C12.1984 8.7045 12.3066 8.7141 12.386 8.6583L13.36 7.9761C13.5786 8.0963 13.8096 8.1917 14.049 8.2609L14.2442 9.4331C14.26 9.5293 14.3434 9.5999 14.4412 9.5999H15.5412C15.6382 9.5999 15.7212 9.5303 15.738 9.4349L15.947 8.2569C16.1868 8.1863 16.4166 8.0903 16.633 7.9699L17.614 8.6581C17.6936 8.7143 17.8016 8.7045 17.8704 8.6359L18.648 7.8577C18.7172 7.7883 18.7262 7.6789 18.6688 7.5993L17.9692 6.6279C18.0878 6.4119 18.182 6.1835 18.2506 5.9463L19.4342 5.7385C19.53 5.7217 19.5996 5.6385 19.5996 5.5415V4.4415C19.5998 4.3435 19.5288 4.2599 19.432 4.2441ZM15 6.3999C14.2268 6.3999 13.6 5.7731 13.6 4.9999C13.6 4.2267 14.2268 3.5999 15 3.5999C15.7732 3.5999 16.4 4.2267 16.4 4.9999C16.4 5.7731 15.7732 6.3999 15 6.3999Z",
    fill: "#1B51A4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_410"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryCarIcon);
export default __webpack_public_path__ + "static/media/delivery-car-icon.a226f124d8fdbb1368b2c5e79c044c42.svg";
export { ForwardRef as ReactComponent };